import React from 'react';

import { cn } from '../../../tailwind-base/utils';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

interface Props {
  sub?: boolean;
  discount?: number;
  hex?: string;
  message?: string | null;
  className?: string | null;
}

export default function Badge({
  sub = false,
  discount = 5,
  hex = '',
  message = null,
  className = '',
}: Readonly<Props>) {
  const { tt } = useUiComponentsInternationalContext();

  if (message === null && sub === false) return null;
  let bgc = hex || 'bg-green';
  let txc = 'text-foreground-xdark';
  let txt = message;

  if (sub === true) {
    bgc = 'bg-brand-dark';
    txc = 'text-white';

    txt =
      message ??
      tt(s => s.badgeLabelsComponent.saveWithAutoshipLabel, {
        discount: discount.toString(),
      });
  }

  return (
    <div
      style={{
        backgroundColor: hex,
      }}
      className={cn(
        `inline-flex py-1 px-3 justify-center items-center rounded-md`,
        bgc,
        className
      )}
    >
      <p className={cn('mb-0 text-sm font-bold', txc)}>{txt}</p>
    </div>
  );
}
